export function statusPillClass(status){
  const green = ['ativo','ativa','reaprovado','active','aprovada','paid','paga','done','ok','pronto','enviado','fulfilled','verificada'];
  const amber = ['em revisão','em recurso','pausada','pendente','inactive','autorizada','authorized','pending','parcialmente paga','partially_paid','queued','products','orders','syncing','parcial','partial','sincronizando','rascunho','draft','unfulfilled','não verificada','manual'];
  const red = ['banido','desativada','perdido','cancelada','cancelled','reembolsada','refunded','anulada','voided','parcialmente reembolsada','partially_refunded','error','erro','arquivado','archived'];
  if(green.includes(status)) return 'pill-green';
  if(amber.includes(status)) return 'pill-amber';
  if(red.includes(status)) return 'pill-red';
  return 'pill-neutral';
}
